import RentalPayment from "./RentalPayment";
import PaymentInfo from "./PaymentInfo";
import SellPayment from "./SellPayment";
import {useContext} from "react";
import PaymentContext from "../../../store/PaymentContext";
import {checkHasData} from "../util";

const Payment = ({ setLoading } : any) => {

    const {
        rentCarts,
        sellCarts,
    } = useContext(PaymentContext);

    const isShowRent = checkHasData(rentCarts)
    const isShowSell = checkHasData(sellCarts)

    return (
        <div className="m-auto flex flex-col gap-4 px-4">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4">
                <div className="col-span-1 md:col-span-3">
                    <div className="h-auto">
                        <RentalPayment isShowRent={isShowRent} isShowSell={isShowSell} />
                        <SellPayment isShowRent={isShowRent} isShowSell={isShowSell} />
                    </div>
                </div>
                <div className="col-span-1">
                    <PaymentInfo setLoading={setLoading}/>
                </div>
            </div>
        </div>
    )
}

export default Payment;
